// src/components/AuthRedirect.js

import React from 'react';
import { Navigate } from 'react-router-dom';

const AuthRedirect = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('token');

  if (isAuthenticated) {
    // Jeśli użytkownik JEST zalogowany, przekieruj go do aplikacji
    return <Navigate to="/app" replace />;
  }

  // Jeśli NIE jest zalogowany, pozwól mu zobaczyć stronę (np. marketingową, logowania)
  return children;
};

export default AuthRedirect;